
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningHeavySnowShowersDayColour as ObiLightningHeavySnowShowersDayColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-heavy-snow-showers-day-colour.js';
 
 
 

 
 export const ObiLightningHeavySnowShowersDayColour = createComponent({
   react: React,
   tagName: 'obi-lightning-heavy-snow-showers-day-colour',
   elementClass: ObiLightningHeavySnowShowersDayColourElement,
   events: {
     
   }
  });
 
 